import { Flex } from "@/common/styles";
import styled from "styled-components";

export const FlagContainer = styled(Flex)`
  --skew-angle: -30deg;
  --skew-anti-angle: 30deg;
  --flag-types-color: #7eacff;

  .flag * {
    transition: all 0.3s ease;
  }

  .flag-btn {
    width: auto;
    z-index: 9;
    height: 45px;
    min-width: 45px;
    align-items: center;
    justify-content: center;
    border-radius: ${({ skew }) => skew && "11px 0 11px 0"};
    margin-right: 2px;
    cursor: pointer;
    transition: all 0.3s ease;
    -webkit-backface-visibility: hidden;
    -webkit-transform: ${({ skew }) => skew && `skew(var(--skew-angle), 0)`};
    padding: 0 5px;
    position: relative;
    ${({ isExpanded = false }) => isExpanded && `padding-left: 10px`};
    border-color: transparent;
    background: var(--flag-types-color);
    box-shadow:
      2px 2px 7px 0 rgba(0, 0, 0, 0.4),
      inset 0 1px 0 0 var(--flag-types-color),
      inset 0 -1px 0 0 var(--flag-types-color);
    &.warrants {
      --flag-types-color: var(--flag-color-warrants);
    }

    &.civil {
      --flag-types-color: var(--flag-color-civic);
    }

    &.danger {
      --flag-types-color: var(--flag-color-danger);
    }

    &.in-jail {
      --flag-types-color: var(--flag-color-in-jail);
    }

    &.gang {
      --flag-types-color: var(--flag-color-gang);
    }

    &.notes {
      --flag-types-color: var(--flag-color-notes);
    }

    &.medical {
      --flag-types-color: var(--flag-color-medical);
    }

    &.enabled {
      opacity: 1;
    }

    &:not(.enabled) {
      .flag-main-icon {
        opacity: 0.7;
      }
      background: #798b97;
      box-shadow: none;
      cursor: not-allowed;
      pointer-events: none;
    }

    &.enabled:not(.expanded) {
      box-shadow:
        0 0 2px rgba(0, 0, 0, 0.3),
        0 0 6px var(--flag-types-color, #fff),
        0 0 6px var(--flag-types-color, #fff),
        inset 0 0 4px rgba(255, 255, 255, 0.2);
      img {
        -webkit-animation-name: blinker;
        -webkit-animation-duration: 0.6s;
        -webkit-animation-iteration-count: infinite;
        -webkit-animation-timing-function: ease-in-out;
        -webkit-animation-direction: alternate;
      }
    }
  }
  .flag {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    transform: skew(var(--skew-anti-angle), 0);
    -webkit-transform: skew(var(--skew-anti-angle), 0);
    -moz-transform: skew(var(--skew-anti-angle), 0);

    .flag-info {
      position: relative;
      width: 100%;
      height: 100%;
      display: none;
      padding-left: 10px;
      padding-right: 20px;
      align-items: center;
    }

    .flag-name {
      white-space: nowrap;
      color: #ffffff;
      text-shadow: 0px 1px 1px rgba(0, 0, 0, 0.2);
    }

    .count {
      margin-left: 15px;
      padding: 2px 10px;
      color: #ffffff;
      background-color: rgba(0, 0, 0, 0.4);
      border-radius: 50px;
    }
  }

  .flag.ant-popover-open {
    min-width: 125px;
    .flag-info {
      display: flex;
    }
    .flag-main-icon {
      margin-left: 20px;
    }
  }

  &.FLAGTYPES_WARRANTS {
    --flag-color: #5b86ff;
    background: var(--flag-color);
    box-shadow:
      2px 2px 7px 0 rgba(0, 0, 0, 0.4),
      inset 0 1px 0 0 #7eacff,
      inset 0 -1px 0 0 #3765e7;
  }

  &.CIVIL_PAPER_STATUS {
    --flag-color: #93be00;
    background: var(--flag-color);
    box-shadow:
      2px 2px 7px 0 rgba(0, 0, 0, 0.4),
      inset 0 1px 0 0 #b5e11e,
      inset 0 -1px 0 0 #5aa201;
  }

  &.FLAGTYPES_DANGER {
    --flag-color: #f22643;
    background: var(--flag-color);
    box-shadow:
      2px 2px 7px 0 rgba(0, 0, 0, 0.4),
      inset 0 1px 0 0 #ff6077,
      inset 0 -1px 0 0 #cc004f;
  }

  &.FLAGTYPES_INJAIL {
    --flag-color: #ff6b00;
    background: var(--flag-color);
    box-shadow:
      2px 2px 7px 0 rgba(0, 0, 0, 0.4),
      inset 0 1px 0 0 #ff9142,
      inset 0 -1px 0 0 #e44800;
  }

  &.FLAGTYPES_GANG {
    --flag-color: #b747ff;
    background: var(--flag-color);
    box-shadow:
      2px 2px 7px 0 rgba(0, 0, 0, 0.29),
      inset 0 1px 0 0 #ca77ff,
      inset 0 -1px 0 0 #9a10f2;
  }

  &.FLAGTYPES_MEDICAL {
    --flag-color: #00b6b9;
    background: var(--flag-color);
    box-shadow:
      2px 2px 7px 0 rgba(0, 0, 0, 0.4),
      inset 0 1px 0 0 #23e4e8,
      inset 0 -1px 0 0 #0090b9;
  }

  &.FLAGTYPES_NOTES {
    --flag-color: #ffb500;
    background: var(--flag-color);
    box-shadow:
      2px 2px 7px 0 rgba(0, 0, 0, 0.29),
      inset 0 1px 0 0 #ffe279,
      inset 0 -1px 0 0 #de830a;
  }

  @keyframes blinker {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }
  @-webkit-keyframes blinker {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }

  @keyframes slideIn {
    from {
      opacity: 0;
      transform: translateX(20px);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }
`;

export const ExpandedContent = styled(Flex)`
  position: absolute;
  left: 0px;
  top: 0;
  width: 100%;
  height: 100%;
  display: ${({ isExpanded = false }) => (isExpanded ? "flex" : "none")};
  color: white;
  text-transform: uppercase;
  font-weight: 500;
  /* font-size: 17px; */
  margin: 0 5px 0 10px;
  align-items: center;
  justify-content: center;

  .flag-name {
    white-space: nowrap;
  }

  .count {
    margin-left: 15px;
    padding: 2px 10px;
    background-color: rgba(0, 0, 0, 0.3);
    border-radius: 50px;
  }

  .close {
    flex-basis: 15px;
    margin-left: 15px;
    display: flex;
    align-items: center;
    justify-content: center;

    & img {
      width: 100%;
      min-width: 15px;
    }
  }
`;

export const FlagDetails = styled.div`
  // display: ${({ isExpanded = false }) => (isExpanded ? "block" : "none")};
  // position: absolute;
  --flag-type-color: #84b0ff;
  margin-top: 15px;
  left: 0px;
  width: 400px;
  block-size: fit-content;
  border: 4px solid var(--flag-type-color);
  border-radius: var(--border-radius);
  z-index: 99999;
  background-color: #10143a;
  cursor: default;
  color: white;
  height: 270px;
  font-weight: 100;
  overflow: auto;
  transform: skew(var(--skew-anti-angle), 0);
  -webkit-transform: skew(var(--skew-anti-angle), 0);

  & ul {
    list-style: none;
    padding: 15px;
    margin: unset;
  }

  & ul li {
    margin-bottom: 10px;

    &:last-child {
      margin-bottom: unset;
    }
  }

  .header {
    text-transform: uppercase;
    color: #84b0ff;
    margin-bottom: 10px;
    font-weight: 900;
  }

  &.flag-content {
    .flag-type-header {
      display: flex;
      justify-content: space-between;
      padding: 5px 10px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.9);
      h5 {
        color: var(--flag-type-color, #ffffff);
        font-size: 1.32rem;
        text-shadow: 0px 1px 1px rgba(0, 0, 0, 0.9);
        margin: 0px;
      }
    }
    &.warrants {
      --flag-type-color: var(--flag-color-warrants);
    }

    &.civil {
      --flag-type-color: var(--flag-color-civic);
    }

    &.danger {
      --flag-type-color: var(--flag-color-danger);
    }

    &.in-jail {
      --flag-type-color: var(--flag-color-in-jail);
    }

    &.gang {
      --flag-type-color: var(--flag-color-gang);
    }

    &.notes {
      --flag-type-color: var(--flag-color-notes);
    }

    &.medical {
      --flag-type-color: var(--flag-color-medical);
    }
  }
`;
